import React, { FC } from 'react';

import { Stack, Text } from '@chakra-ui/react';

import { KnowledgeBaseDrawer } from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseDrawer';
import {
  KnowledgeBaseLink,
  KnowledgeBaseLinks,
} from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseLinks';
import { LearnMoreInlineLink } from 'components/DataDisplay/KnowledgeBase/BaseComponents/LearnMoreInlineLink';

export const LearnMoreAboutBlueprints: FC = () => {
  const links: KnowledgeBaseLink[] = [
    { label: 'Policies', field: 'policies' },
    { label: 'Findings', field: 'findings' },
    { label: 'Exceptions', field: 'exceptions' },
  ];

  return (
    <KnowledgeBaseDrawer
      knowledgeBaseKey="blueprints"
      headerTitle="Policy Blueprints"
      body={
        <Stack spacing={10}>
          <Stack spacing={4}>
            <Text fontWeight={600}>Overview</Text>
            <Text>
              Policy blueprints are the foundations of policy management for
              your cloud accounts. Policy blueprints contain individual{' '}
              <LearnMoreInlineLink label="policies" field="policies" value />{' '}
              that are continuously evaluated for policy violations in
              environments. Blueprints can contain both standard policies
              (provided by Ariksa) and custom policies that are created by you.
              All policy blueprints in your organization are shown in the Policy
              Hub.
            </Text>
          </Stack>
          <Stack spacing={4}>
            <Text fontWeight={600}>Lifecycle Management</Text>
            <Text>
              You can create policy blueprints from scratch or create copies of
              policy blueprints using existing blueprints. When creating
              blueprints from scratch, you’ll need to add policies manually to
              the blueprints. However, creating copies allowing you to simply
              delete the policies that you don’t need enforced. Once a blueprint
              has been finalized, you can attach the blueprint to one or more
              environments for continuous assessment against policies present in
              the blueprint.
            </Text>
          </Stack>
          <Stack spacing={4}>
            <Text fontWeight={600}>Exceptions</Text>
            <Text>
              Policy or resource exceptions are recorded within a policy
              blueprint. Policy exceptions are applied automatically to every
              environment to which the blueprint is attached. However, resource
              exceptions are limited to the specific resource (and the
              environment in which the resource is deployed) to which it
              applied.
            </Text>
          </Stack>
          <KnowledgeBaseLinks links={links} />
        </Stack>
      }
    />
  );
};
